/**
 * @module components\ghDynamicInvoke
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model } from "vue-property-decorator";
import { MethodService } from "@/utils/serviceModel";

@Component
export default class GhDynamicInvoke extends Vue {
  @Model("change")
  private value!: any;
  @Prop()
  private sourceId!: string;
  @Prop({ default: () => {} })
  private args!: any;
  @Prop({ default: true })
  private isIntial!: boolean;

  private loading = false;

  private data: any = null;

  private codeOptions = {
    readOnly: false,
    language: "javascript",
    autoIndent: true,
    automaticLayout: true
  };

  private invoke(args?: {}) {
    this.invokeAsyn(args);
  }

  private async invokeAsyn(args?: {}) {
    let svInvoke = new MethodService(
      "dynamic_value_resolve",
      "",
      this.sourceId
    );
    if (args) {
      this.args = args;
    }
    try {
      this.loading = true;
      let res = await svInvoke.invokeAsyn(this.args);
      if (res.data.isSuccess) {
        this.data = res.data.data;
        this.$emit("change", this.data);
      } else {
        this.data = null;
        this.$emit("change", this.data);
      }
    } catch (error) {
      this.data = null;
      this.$emit("change", this.data);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    if (this.isIntial) {
      this.invokeAsyn();
    }
  }
}
